import { css, styled } from 'styled-components'

import { mq } from 'styles/mq'
import { typography } from 'styles/typography'
import { resetButtonStyle } from 'styles/utils'

export const Title = styled.h3`
  ${typography.heading.h3}
  margin-block-start: 0;
  padding-inline: 3em;
  text-align: center;
  hyphens: none;
  line-height: 1.15;

  ${mq.smallOnly} {
    position: sticky;
    left: 0;
  }
`

export const NavButton = styled.button<{ $align?: 'left' | 'right' }>`
  ${resetButtonStyle}
  display: flex;
  align-items: center;
  position: absolute;
  top: -1.9rem;
  left: 0;
  padding-block: 1rem;
  margin-inline: 1rem;
  font-size: 4rem;
  cursor: pointer;
  color: var(--primary-color);

  ${mq.medium} {
    top: -2.7rem;
    font-size: 5.6rem;
    margin-inline: -1.5rem;
  }

  ${mq.large} {
    margin-inline: -2rem;
    top: -3.6rem;
    font-size: 7.2rem;
  }

  &:disabled {
    cursor: auto;
    color: var(--grey);
    opacity: 0.3;
  }

  ${props =>
    props.$align === 'right' &&
    css`
      left: auto;
      right: 0;
      transform: rotate(-180deg);
    `}
`

export const Description = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  max-width: 68rem;
  width: 100%;
  margin: 4rem auto;

  ${mq.smallOnly} {
    overflow: hidden;
    padding-bottom: 1rem;
    padding-inline: 0 2rem;
    margin: 3rem auto;

    p:first-child {
      margin-block-start: 0;
    }

    p:last-child {
      margin-block-end: 0;
    }
  }

  a {
    color: var(--primary-color);
  }
`

export const Scroll = styled.div`
  text-align: justify;
  hyphens: auto;

  ${mq.smallOnly} {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    overflow-x: scroll;
    padding-inline: 2rem 0;
    scrollbar-width: none;
    scroll-snap-type: x mandatory;
  }

  ${mq.medium} {
    width: 100%;
  }
`

export const ScrollText = styled.div`
  ${mq.smallOnly} {
    column-width: calc(100vw - 4rem);
    column-gap: 4rem;
    column-count: auto;
    column-fill: auto;
    orphans: 2;
    height: 0;
    flex-grow: 1;
  }
`

export const Pagination = styled.ul`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  gap: 0.4rem;
  list-style: none;

  ${mq.medium} {
    display: none;
  }
`

export const Page = styled.li<{ $isActive: boolean }>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.2s;
  background-color: ${props =>
    props.$isActive ? 'var(--primary-color)' : 'var(--border-color)'};
`

export const SnapPoints = styled.div`
  display: flex;
  width: calc(2rem + (100% + 4rem) * var(--number-of-pages));
  margin-left: -2rem;

  ${mq.medium} {
    display: none;
  }
`

export const SnapPoint = styled.div`
  height: 1px;
  width: 100vw;
  flex: none;
  scroll-snap-align: start;
`
